import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rhv8snb8e: FaireProductEntity = {
  token: "p_7rhv8snb8e",
  type: "product",
  name: "STAINLESS STEEL WATERPROOF TARNISH FREE BRACELET | 40B112",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/4146716c8bab96a55005fd5d42927c0b31b1538fc98204dd0c8a5f69cd77c47b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/edb3788ca67e8932024454c462a6fb8f643525cfbbfa74d2c256d0a7fae64c6b.jpeg",
    "https://cdn.faire.com/fastly/f304773a12e785e3bf93c2d87dedcbc17088e3ba39f91dae51572ddfe368ee88.jpeg",
    "https://cdn.faire.com/fastly/e7b06d971b3f39d501f399c36f3ac30c5ae95310a821b666a62c11ac4fd86a82.jpeg",
    "https://cdn.faire.com/fastly/bfe355713d73bdf6889be99ae1db6020fc70467030f630e28a72c9807f4e7fbd.jpeg",
    "https://cdn.faire.com/fastly/e9ab24b6089051b8bb861961c88177c9067586b90eaeb3dfe6698908ed2210d4.jpeg",
    "https://cdn.faire.com/fastly/e71133395eb9608e5532641bda2ddd53830ec883144c6e0b187c9132ef058d2f.jpeg",
    "https://cdn.faire.com/fastly/74250d6c81299dfe27ca454718ade44d69b0cf2eec5c4ec077fee1ed6bfcfd4a.jpeg",
    "https://cdn.faire.com/fastly/7d956a4055e5ee2d7682fc44f1e7561e3570693897ff48c94539f8b4820b0a3e.jpeg",
    "https://cdn.faire.com/fastly/032d889085e51718cd53bb17acb7a5131d467ce0fb60ef6a36d1a0705b10b6ff.jpeg",
    "https://cdn.faire.com/fastly/01b0c17dd81702e354f43cac8baa5c1570a23fb13b3c27005e10933a3c425ddb.jpeg",
    "https://cdn.faire.com/fastly/f268b9c13a4169ca1ad75f65417e1aedca011d00324240d382b647ee7f0245f9.jpeg",
    "https://cdn.faire.com/fastly/4505b7530c914974a36be3ad6879c8fbe4d0e8e7804daab770fe71e08afb6583.jpeg",
    "https://cdn.faire.com/fastly/2c178e628a4c8cb75e365ebe796346b3a5cde1bf1c209a5dffa13e8c3fddaee8.jpeg",
    "https://cdn.faire.com/fastly/9b337535140ecb2c78c5a797bb1ce7e709d0c48c53af1534b0c52728a746e72e.jpeg",
  ],
  priceDollars: 3.81,
  description:
    'Stainless Steel Waterproof Tarnish-Free All Different Chain Bracelet, a unique and versatile accessory designed to elevate your style with modern flair. Our Bracelet features a captivating blend of various chain designs.  Paperclip Chain, Curb Chain, Rope Chain, Herringbone Chain.\n\nMatching Necklace SKU# 40NK318\n\nProduct Details:\nlength:  6.7"\next: 2" ext\nclasp: Lobster Claw\nMetal finish: Stainless Steel 18K Gold\nproduct: Lead & Nickel Compliant\nanti-tarnish:  Tarnish Free, Non-Tarnish\n\nReal Gold Dipped Bracelet\nStainless Steel Bracelet\nHypoallergenic Bracelet\nTarnish-Free Bracelet\nNon-Tarnish Bracelet\nWater Proof Bracelet\nWater Resistant Bracelet\nSweatproof Jewelry\nFade Resistant Bracelet\nAnti-oxidation \n\nLayered Chain Bracelet | Herringbone Link Bracelet | Snake Chain Bracelet | Real Gold Dipped Bracelet | Layering Bracelet | Simple Gold Bracelet',
  tags: [],
  msrpDollars: 7.62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:40.641Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
